export const premium_hangers = {
  product_id: "8",
  grid_type: "1",
  cover_image: "/1.jpg",
  product_name: "Premium Kleiderbügel x 3",
  media: ["1.jpg", "2.jpg", "3.jpg", "4.jpg"],
  product_price: 38.9,
  product_slug: "premium-hangers",
  short_description: "Die Premium Kleiderbügel aus hochwertigem Acrylglas vereinen Funktionalität mit zeitloser Eleganz. Ihr schlankes, platzsparendes Design sorgt für eine stilvolle Organisation Ihrer Garderobe, während die diamantgeschliffenen Ränder einen Hauch von Luxus verleihen.",
  description: `
  Verbessern Sie Ihre Garderobe mit unübertroffener Eleganz.
  <br><br>
  Wir stellen Ihnen unsere exquisiten Premium Kleiderbügel vor, bei denen Funktionalität auf Raffinesse trifft.
  <br><br>
  Erhöhen Sie die Präsentation Ihrer geschätzten Kleidungsstücke mit der zeitlosen Schönheit von klarem Acrylglas. Diese Kleiderbügel werden sorgfältig aus hochwertigem Acrylglas gefertigt und setzen einen neuen Standard für Haltbarkeit und Vielseitigkeit. Egal, ob Sie feine Kleider oder schwere Mäntel aufhängen, unsere Premium Kleiderbügel sind so konzipiert, dass sie Ihre gesamte Garderobe sicher halten. Das schlanke und platzsparende Design unserer Kleiderbügel optimiert nicht nur die Organisation Ihres Kleiderschranks, sondern verleiht Ihrer Garderobe auch eine moderne und organisierte Ästhetik.
  <br><br>
  Jeder Kleiderbügel ist ein Statement für modernen Stil und durchdachtes Design. Überraschen Sie Ihre modebewussten Freunde und Bekannten mit diesen „Premium Kleiderbügeln aus Acrylglas" – ein praktisches und stilvolles Geschenk für jede Gelegenheit. Werten Sie Ihren Kleiderschrank auf, zeigen Sie Ihren Sinn für Mode und gönnen Sie sich den Luxus von gut verarbeiteten Accessoires aus unserer Kollektion.
  <br><br>
  <h6> PRODUKTPFLEGE </h6>
  Um das makellose Aussehen Ihrer „Premium Kleiderbügel " zu erhalten, verwenden Sie ein weiches, trockenes Tuch, um Staub zu entfernen, der sich im Laufe der Zeit ansammeln kann. So sieht Ihr Neujahrsferien-Set am besten aus und behält seine transparente Brillanz.
  <br><br>
  Wenn Sie diese Pflegerichtlinien befolgen, können Sie sicherstellen, dass Ihr „Premium Kleiderbügel "weiterhin glänzt und Ihre Inneneinrichtung über Jahre hinweg bereichert.
  `,
  specifications: {
    rows: [
      { name: "Material", value: "Hochwertiges Acrylglas" },
      { name: "Abmessungen", value: "42,7cm x 16,8cm x 0,5cm" },
      { name: "Gewicht", value: "188 Gramm" },
      { name: "Farbe", value: "Transparent" },
      { name: "Ränder", value: "Diamantgeschliffen" },
    ],
    description: `Diese Spezifikationen unterstreichen die hochwertige Qualität und Präzision Ihres „Premium Kleiderbügel"-Produkts und machen potenziellen Kunden deutlich, was sie in Bezug auf Material, Größe, Gewicht, Farbe und Verarbeitung erwarten können.`,
  },
  category: "Table",
  title_color: "#00000",
  subtitle_color: "#999999",
  price_color: "#ffffff"
};
